import { eq, useLiveQuery } from "@tanstack/react-db";
import type { OrderWithPickStatus } from "../db/collections";
import { useGlobalConversationCollections } from "../providers/global-conversation-collections-context";

export interface UseCustomerOrdersResult {
  orders: OrderWithPickStatus[];
  pending: boolean;
  error: Error | undefined;
}

export function useCustomerOrders(
  customerEmail?: string | null,
): UseCustomerOrdersResult {
  const { orders: ordersCollection } = useGlobalConversationCollections();

  const ordersQuery = useLiveQuery(
    (q) =>
      q
        .from({ order: ordersCollection })
        .where(({ order }) => eq(order.shopify.email, customerEmail ?? "")),
    [customerEmail],
  );

  // If no email provided, return empty results without querying
  if (!customerEmail) {
    return { orders: [], pending: false, error: undefined };
  }

  return {
    orders: ordersQuery.data ?? [],
    pending: ordersQuery.isLoading,
    error: ordersQuery.isError
      ? new Error("Failed to get customer orders from collection")
      : undefined,
  };
}
